import { defaultHttpClient } from '../../httpClient';
import type { GoodsReviewsAvailableInfoResponse } from './types';

/**
 * - 상품 리뷰 스킨 정보 사용 가능 여부 조회 API
 */
export const getGoodsReviewsAvailableInfo = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsReviewsAvailableInfoResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/reviews/available-info/`,
    })
    .then(result => result.data);
};